import $ from 'jquery';

class VisibilityToggle {

  constructor() {

    // Add active class to first question and answer upon constructor call
    $('.cmp-broker-questions__question:first').addClass('active');
    $('#cmp-broker-questions__answer-0').addClass('active');

    // Add event listeners to each question
    $('.cmp-broker-questions__question').each(function() {
      this.addEventListener('mouseover', function() {

        // Remove all active classes
        $('.cmp-broker-questions__question').removeClass('active');
        $('.cmp-broker-questions__answer').removeClass('active');

        // Set selected question active
        $(this).addClass('active');

        // Find corresponding answer
        let answerId = '#cmp-broker-questions__answer-' + this.dataset.indexNumber;

        // Set answer active
        $(answerId).addClass('active');
      });

    });

    $('.cmp-03-benefits__button').on('keypress click', function(e) {
      e.preventDefault();
      if (e.which === 13 || e.type === 'click') {
        $('.cmp-03-benefits__column.additional').toggleClass('hidden');
        $('.cmp-03-benefits .showMore').toggleClass('less');
      }
    });

    $('.geno-broker__menu-toogle').on('keypress click', function(e) {
      e.preventDefault();
      if (e.which === 13 || e.type === 'click') {
        $('.mainnav.responsive').toggleClass('hidden');
      }
    });

  }
}

export default VisibilityToggle;



// WEBPACK FOOTER //
// ./js/modules/visibilityToggle.js